export enum FiltroTipoEstadisticasAgentes{
  Tabla = 'Tabla',  
  Indicador = 'Indicador',
  Agente = 'Agente'
  }
